import * as React from 'react';
import { Props } from 'react';

import './DialogView.scss';
import i18next from 'i18next';

interface CurrenciesLongDialogViewProps extends Props<CurrenciesLongDialogView> {

}

export class CurrenciesLongDialogView extends React.Component<CurrenciesLongDialogViewProps> {
    render() {
        return (
            <div className='dialog-container'>
                <div className='dialog-client-message'>
                    {i18next.t('exchange_rates')}
                </div>
                <div className='clearfix' />
                <div className='dialog-bot-message'>
                    <div dangerouslySetInnerHTML={{__html: i18next.t('which_currency')}} />
                </div>
                <div className='clearfix' />
                <div className='dialog-client-message'>
                    {i18next.t('usd_to_rub')}
                </div>
                <div className='clearfix' />
                <div className='dialog-bot-message'>
                    {i18next.t('dollar_rate_answer')}
                </div>
                <div className='clearfix' />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CleverBot/Home/Dialogs/CurrenciesLongDialogView.tsx